import React from "react";
import { useNavigate } from "react-router-dom";
import { Linkedin, MapPin, MessageCircle } from "lucide-react";
import { footer, company, contact, social } from "../mock";
import Logo from "./Logo";
import { useEnquiry } from "./EnquiryProvider";

export default function Footer() {
  const navigate = useNavigate();
  const enquiry = useEnquiry();
  const goHash = (hash) => {
    if (window.location.pathname !== "/") {
      navigate("/");
      setTimeout(() => document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" }), 220);
    } else {
      document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  const waHref = `https://wa.me/${social.whatsapp}`;

  return (
    <footer className="bg-[#0d1640] text-white pt-16 pb-8">
      <div className="kse-container">
        <div className="mb-14 rounded-3xl bg-gradient-to-r from-[#1a2a6b] to-[#2b3aa0] p-7 sm:p-10 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
          <div>
            <p className="kse-eyebrow kse-eyebrow--light">Next step</p>
            <h3 className="text-2xl sm:text-3xl font-extrabold leading-tight">Tell us the style, the quantity and the date.</h3>
            <p className="text-blue-100/75 mt-2">A quote within one working day &mdash; and a sample plan if you need one.</p>
          </div>
          <button onClick={() => enquiry?.openEnquiry()} className="kse-btn bg-white text-[#1a2a6b] self-start lg:self-auto hover:shadow-xl">
            Start a manufacturing enquiry
          </button>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="mb-5">
              <Logo />
            </div>
            <p className="text-blue-100/60 text-sm leading-relaxed flex items-start gap-2">
              <MapPin size={16} className="mt-0.5 shrink-0" /> {footer.address}
            </p>
            <p className="text-blue-100/40 text-xs mt-4">{company.established}</p>
          </div>

          {footer.columns.map((col) => (
            <div key={col.title}>
              <h4 className="font-bold mb-5">{col.title}</h4>
              <ul className="space-y-3">
                {col.links.map((l) => (
                  <li key={l}>
                    <button onClick={() => goHash("#about")} className="text-blue-100/60 hover:text-white text-sm transition-colors">{l}</button>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h4 className="font-bold mb-5">Contact Us</h4>
            <a href={`tel:${contact.phone}`} className="block text-blue-100/60 hover:text-white text-sm mb-2">Tel: {contact.phone}</a>
            <a href={`mailto:${contact.people[0].email}`} className="block text-blue-100/60 hover:text-white text-sm mb-5 break-all">{contact.people[0].email}</a>
            <div className="flex items-center gap-3">
              <a href={social.linkedin} target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 hover:bg-white hover:text-[#1a2a6b] flex items-center justify-center transition-all" aria-label="LinkedIn">
                <Linkedin size={18} />
              </a>
              <a href={waHref} target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#25D366] flex items-center justify-center transition-all" aria-label="WhatsApp">
                <MessageCircle size={18} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-blue-100/40 text-sm">
            &copy; {new Date().getFullYear()} {company.name} All Rights Reserved.
          </p>
          <p className="text-blue-100/30 text-xs">
            Website designed by{" "}
            <a href="https://azizsaif.com" target="_blank" rel="noopener noreferrer" className="text-blue-200/70 hover:text-white underline underline-offset-2">
              Azizsaif.com
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
